// extracted by mini-css-extract-plugin
export var halfwidth = "fullfillment-module--halfwidth--e63c2";
export var image_33 = "fullfillment-module--image_33--e2016";
export var text_fullfilled = "fullfillment-module--text_fullfilled--cd357";
export var text_margin_left = "fullfillment-module--text_margin_left--c7a98";
export var text_margin_right = "fullfillment-module--text_margin_right--62854";